<template>
  <v-dialog
    v-model="open"
    max-width="500px"
    @click:outside="closeModal()"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Payment Created</span>
      </v-card-title>

      <v-card-text>
        <v-list dense>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Autopay ID</v-list-item-title>
              <v-list-item-subtitle>
                {{ paymentData.id }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Method</v-list-item-title>
              <v-list-item-subtitle>
                {{ paymentData.payment_account }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Date</v-list-item-title>
              <v-list-item-subtitle>
                {{ paymentData.date }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Type</v-list-item-title>
              <v-list-item-subtitle>
                {{ paymentData.payment_type }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Amount</v-list-item-title>
              <v-list-item-subtitle>
                ${{ paymentData.amount }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <p>Would you like to perform another task or mark this ticket as solved?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          @click="anotherTask()"
        >
          Another Task
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PDSPaymentCreatedModal',

  props: {
    paymentModal: {
      type: Boolean,
      required: false,
      default: false,
    },

    paymentData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      open: false,
    };
  },

  watch: {
    paymentModal(newValue) {
      this.open = newValue;
    },
  },

  created() {
    this.open = this.paymentModal;
  },

  methods: {
    closeModal() {
      this.$emit('closeModal');
    },

    anotherTask() {
      this.$emit('closeModal');
    },
  },
};
</script>
